import md5 from "md5"
import {RequestAccessSecret} from "@/utils/constant";
import {nanoid} from "nanoid";
export const getSign = (string) => {

  return md5(string+RequestAccessSecret.toString())
}
export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}


export const getNanoId = (size = 21) => {
  return nanoid(size);
}

